import React from 'react'
import { isEmpty } from 'util/arrays'
import { Button, Dropdown } from 'util/ui'
import { propFunc } from 'util/functions'
import IntegrationError from 'shared/ui/IntegrationError'
import mailchimpLogo from 'assets/integrations/mailchimp.svg'
import campaignmonitorLogo from 'assets/integrations/campaignmonitor.png'
import constantcontactLogo from 'assets/integrations/constantcontact.png'
import EmptyMessage from '../shared/EmptyMessage'
import Section from '../shared/Section'
import InAppCard from '../shared/InAppCard'
import SubscriptionList from './SubscriptionList'

const getLogo = type => {
  switch (type) {
    case 'MAILCHIMP':
      return mailchimpLogo
    case 'CAMPAIGN_MONITOR':
      return campaignmonitorLogo
    case 'CONSTANT_CONTACT':
      return constantcontactLogo
    default:
      return null
  }
}

export default function EmailMarketingView({
  type,
  subscriptions,
  availableLists,
  isFailed,
  isLoading,
  load,
  onUnsubscribe,
  onSubscribe,
}) {
  const openStateKey = `email-${type}`
  const baseProps = {
    image: getLogo(type),
    key: openStateKey,
    openStateKey,
    title: type,
  }

  if (isLoading) {
    return <InAppCard {...baseProps} isLoading />
  }
  if (isFailed) {
    return (
      <InAppCard {...baseProps}>
        <IntegrationError onRetry={load} />
      </InAppCard>
    )
  }
  if (!subscriptions || !availableLists) return null
  return (
    <InAppCard {...baseProps}>
      {subscriptions && (
        <Section label="Subscriptions">
          {isEmpty(subscriptions) && (
            <EmptyMessage>No subscriptions here!</EmptyMessage>
          )}
          {subscriptions && (
            <SubscriptionList
              subscriptions={subscriptions}
              onUnsubscribe={onUnsubscribe}
            />
          )}
        </Section>
      )}
      {!isEmpty(availableLists) && (
        <Section>
          <Dropdown
            trigger={<Button primary>Add to list</Button>}
            icon={null}
            selectOnNavigation={false}
            selectOnBlur={false}
            options={availableLists.map(list => ({
              value: list.id,
              key: list.id,
              text: list.name,
              onClick: propFunc(onSubscribe, list.id),
            }))}
          />
        </Section>
      )}
      {type === 'MAILCHIMP' && (
        <Section help>
          Seeing recently deleted lists, or have lists missing?{' '}
          <a
            href="https://help.groovehq.com/help/setting-up-the-mailchimp-integration"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read this article
          </a>
        </Section>
      )}
    </InAppCard>
  )
}
